import * as Accordion from "@radix-ui/react-accordion";
import { cx } from "class-variance-authority";
import { useLayoutEffect, useRef, useState } from "react";

interface BaseAccordionItemProps {
  value: string;
  header: React.ReactNode;
  trigger: React.ReactNode;
  children: React.ReactNode;
  itemClass?: string;
  headerClass?: string;
  triggerClass?: string;
  contentClass?: string;
  triggerButtonClass?: string;
  triggerButtonOpenClass?: string;
}

export const BaseAccordionItem = (props: BaseAccordionItemProps) => {
  const item = useRef<HTMLButtonElement>();
  const [isOpen, setIsOpen] = useState(false);
  useLayoutEffect(() => {
    if (item.current) {
      const rev = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          const open = (mutation.target as HTMLButtonElement).dataset.state;
          setIsOpen(() => (open === "open" ? true : false));
        }
      });
      rev.observe(item.current, {
        attributes: true,
      });
      return () => {
        rev.disconnect();
      };
    }
  }, []);
  return (
    <Accordion.Item value={props.value} className={props.itemClass}>
      <Accordion.Header className={props.headerClass}>
        <Accordion.Trigger ref={item} className={props.triggerClass}>
          {props.header}
          <span
            className={cx(
              props.triggerButtonClass,
              isOpen ? props.triggerButtonOpenClass : null
            )}
          >
            {props.trigger}
          </span>
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className={props.contentClass}>
        {props.children}
      </Accordion.Content>
    </Accordion.Item>
  );
};
